import React, { useState, useEffect } from "react";

import withStyles from "@mui/styles/withStyles";
import { makeStyles } from "@mui/styles";
import CircularProgress from "@mui/material/CircularProgress";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Select from "react-select";
import moment from 'moment-timezone';

import {
  Box,
  Card,
  CardActions,
  CardContent,
  Divider,
  Button,
  Grid,
  TextField,
  Typography,
} from "@mui/material";

import clsx from "clsx";
import { Autocomplete } from "@mui/material";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { queryUsers } from "apis/userAPIs";
import { getRestaurantById, updateRestaurantById, createRestaurantById } from "apis/restaurantAPIs";

import { useSelector, useDispatch } from "react-redux";

import { updateSelectedRestaurant } from "store/actions/restaurant";

import { RestaurantToolbar } from "./components";
import API from "util/API";
import { useHistory } from "react-router-dom";
// import { showErrorSnackbar } from "store/actions/snackbarMessage";
import AddressField from "components/AddressField";
import PhoneField from "components/PhoneField";
import { validatePhone } from "util/validation";
import { checkAdmin, checkMenuAdmin } from "util/userUtils";
import { merchantTypes } from "./constants/merchantTypes";
import { omitAdminOnlyFields } from "./constants/adminOnlyFields";

import { noWheelInputProps } from "util/utils";
function useUsernameOptions(inputValue) {
  return useQuery({ queryKey: ["usernames", inputValue], queryFn: () => queryUsers(inputValue) });
}

function useRestaurant(restaurantId) {
  return useQuery({
    queryKey: ["restaurant", restaurantId],
    queryFn: () => getRestaurantById(restaurantId),
    enabled: !!restaurantId,
  });
}

const IOSSwitch = withStyles((theme) => ({
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: theme.spacing(1),
  },

  switchBase: {
    padding: 1,
    "&$checked": {
      transform: "translateX(16px)",
      color: theme.palette.common.white,
      "& + $track": {
        backgroundColor: "#52d869",
        opacity: 1,
        border: "none",
      },
    },
    "&$focusVisible $thumb": {
      color: "#52d869",
      border: "6px solid #fff",
    },
  },
  thumb: {
    width: 24,
    height: 24,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} variant="filled" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    padding: theme.spacing(1),
  },

  toolbar: theme.mixins.toolbar,
  root: {
    padding: theme.spacing(1.5),
  },
  details: {
    display: "flex",
  },
  avatar: {
    height: 110,
    width: 100,
    flexShrink: 0,
    flexGrow: 0,
  },
  locationText: {
    paddingLeft: "15px",
  },
  buttonProperty: {
    position: "absolute",
    top: "50%",
  },
  uiProgess: {
    position: "fixed",
    zIndex: "1000",
    height: "31px",
    width: "31px",
    left: "50%",
    top: "35%",
  },
  progress: {
    position: "absolute",
  },
  uploadButton: {
    marginLeft: "8px",
    margin: theme.spacing(1),
  },
  customError: {
    color: "red",
    fontSize: "0.8rem",
    marginTop: 10,
  },
  submitButton: {
    marginLeft: "12px",
    marginTop: "8px",
    marginBottom: "8px",
  },
  cardActions: {
    padding: "16px",
    backgroundColor: "#f5f5f5",
    borderTop: "1px solid #e0e0e0",
  },
}));

const Restaurant = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const queryClient = useQueryClient();
  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");
  const [altName, setAltName] = useState("");
  const [address, setAddress] = useState("");
  const [addressObject, setAddressObject] = useState(null);

  const [abn, setAbn] = useState("");
  const [taxName,  setTaxName] = useState("");
  const [taxPercentage, setTaxPercentage] = useState(10);
  const [restaurantAdmin, setRestaurantAdmin] = useState("");
  const [restrauntDescription, setRestrauntDescription] = useState("");
  const [serviceMonthlyPrice, setServiceMonthlyPrice] = useState(49.95);
  const [longitude, setLongitude] = useState("");
  const [latitude, setLatitude] = useState("");
  const [uiLoading, setUiLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [urlIdentifier, setUrlIdentifier] = useState("");
  const [idError, setIdError] = useState("");
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [openSuccessSnackbar, setOpenSuccessSnackbar] = useState(false);
  const [stripeFeeOnUs, setStripeFeeOnUs] = useState(false);
  const [isApplicationFeeEnabled, setIsApplicationFeeEnabled] = useState(false);
  
  const [fantuanStoreId, setFantuanStoreId] = useState("");
  const [chinaPaymentsMerchantCode, setChinaPaymentsMerchantCode] = useState("");
  const [applicationFee, setApplicationFee] = useState(0);
  const [errorMsg, setErrorMsg] = useState("");
  const [online, setOnline] = useState(false);
  const [imageError, setImageError] = useState(null);
  const [image, setImage] = useState(null);
  const [content, setContent] = useState(null);
  const [takeawayPayment, setTakeawayPayment] = useState(false);
  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState("");

  const [smsVerify, setSmsVerify] = useState(false);
  const [isSMSLoyaltyEnabled, setIsSMSLoyaltyEnabled] = useState(false);
  const [isFranchise, setIsFranchise] = useState(false);
  const [merchantId, setMerchantId] = useState("");
  const [disableAdyenMinimumSurcharge, setDisableAdyenMinimumSurcharge] =
    useState(false);
  const [disableOnlineSurcharge, setDisableOnlineSurcharge] = useState(false);
  const [isClosed, setIsClosed] = useState(false);
  const [isKDSDisabled, setIsKDSDisabled] = useState(false);

  const [timezone, setTimezone] = useState("Australia/Sydney");


  const timezoneOptions = moment.tz.names().map(zone => ({ label: zone, value: zone }));
  const [selectedType, setSelectedType] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedMerchantType, setSelectedMerchantType] = useState(null);
  const [selectedTerminalProvider, setSelectedTerminalProvider] = useState(null);

  const [paymentPartnerCode, setPaymentPartnerCode] = useState("");
  const [paymentPartnerCredential, setPaymentPartnerCredential] = useState("");
  const [onlinePaymentSurchargeRate, setOnlinePaymentSurchargeRate] =
    useState(0);
  const [inPersonPaymentSurchargeRate, setInPersonPaymentSurchargeRate] =
    useState(0);
  const { data: usernameOptions } = useUsernameOptions(restaurantAdmin);
  const user = useSelector((state) => state.account.user);

  const isAdmin = checkAdmin(user);

  const restaurantId = props.match.params.restaurantId;
  const { data: selectedRestaurant, isLoading: isRestaurantLoading } = useRestaurant(restaurantId);

  // Menu Admins may save changes to an existing merchant, but creating one stays
  // admin-only - the create endpoint rejects every other role. checkMenuAdmin is
  // true for admins as well, hence the explicit isAdmin branch for the create page.
  const canSave = isAdmin || (checkMenuAdmin(user) && !!selectedRestaurant);

  const updateMutation = useMutation({
    mutationFn: updateRestaurantById,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["restaurant", restaurantId] });
      setButtonLoading(false);
      setOpenSuccessSnackbar(true);
      setTimeout(() => {
        history.push("/restaurants");
      }, 2000);
    },
    onError: (error) => {
      if (error.response && error.response.status === 403) {
        history.push("/sign-in");
      }
      setButtonLoading(false);
      const errorMessage = error.response?.data?.message || error.message || "Failed to update restaurant";
      setErrorMsg(errorMessage);
      setOpenErrorSnackbar(true);
    },
  });

  const createMutation = useMutation({
    mutationFn: createRestaurantById,
    onSuccess: () => {
      setButtonLoading(false);
      setOpenSuccessSnackbar(true);
      setTimeout(() => {
        history.push("/restaurants");
      }, 2000);
    },
    onError: (error) => {
      if (error.response && error.response.status === 403) {
        history.push("/sign-in");
      }
      setButtonLoading(false);
      const errorMessage = error.response?.data?.message || error.message || "Failed to create restaurant";
      setErrorMsg(errorMessage);
      setOpenErrorSnackbar(true);
    },
  });

  const [uberStoreName, setUberStoreName] = useState("");
  const [hungryPandaStoreId, setHungryPandaStoreId] = useState("");
  const [huePayMerchantNumber, setHuePayMerchantNumber] = useState("");
  const [posSettings, setPosSettings] = useState({
    showRemoveTakeawayOrders: false,
    // When on, the POS Takeaway Orders page offers "Clear All Pickup Orders",
    // which marks every counter pick-up order collected so it drops off Order
    // Calling. Only high-volume merchants who hand orders straight over need it.
    showClearAllPickupOrders: false,
    // When on, a table may carry at most one discount.
    singleDiscountPerTable: false,
    // OA-1643: when on, the POS sends a one-time code to an existing loyalty
    // member's phone or email and only applies their benefits or opens their
    // membership once staff enter it.
    requireMembershipOtp: false
  });
  const [isDeliveryServiceEnabled, setIsDeliveryServiceEnabled] = useState(false);
  const [deliveryServiceOnlineRate, setDeliveryServiceOnlineRate] = useState(0);
  const [deliveryServiceCommissionRate, setDeliveryServiceCommissionRate] = useState(0);
  const [deliveryServiceCommissionDiscount, setDeliveryServiceCommissionDiscount] = useState(0);
  const [deliveryCommissionDiscountError, setDeliveryCommissionDiscountError] = useState("");

  // A rate of 0 is a real setting - "this merchant is charged nothing" - and the
  // field has to hold the intermediate "0" and "0." keystrokes to reach 0.5 at all.
  // The old pattern required a decimal point after a leading zero, so neither "0"
  // nor anything typed from an empty field below 1 could ever be entered.
  const RATE_PATTERN = /^(0|[1-9]\d*)(\.\d{0,3})?$/;

  const handleRateChange = (setter) => (event) => {
    const value = event.target.value;
    if (value === "" || RATE_PATTERN.test(value)) {
      setter(value);
    }
  };

  const validateDeliveryCommissionDiscount = (discountValue, commissionValue) => {
    const discount = Number(discountValue) || 0;
    const commission = Number(commissionValue) || 0;
    if (discount > commission) {
      return "Must be less than or equal to delivery commission rate";
    }
    return "";
  };

  const handleDeliveryCommissionRateChange = (event) => {
    handleRateChange(setDeliveryServiceCommissionRate)(event);
    const commissionValue = event.target.value;
    setDeliveryCommissionDiscountError(
      validateDeliveryCommissionDiscount(deliveryServiceCommissionDiscount, commissionValue)
    );
  };

  const handleDeliveryCommissionDiscountChange = (event) => {
    handleRateChange(setDeliveryServiceCommissionDiscount)(event);
    setDeliveryCommissionDiscountError(
      validateDeliveryCommissionDiscount(event.target.value, deliveryServiceCommissionRate)
    );
  };

  const saveMyRestaurant = (restaurant) =>
    dispatch(updateSelectedRestaurant(restaurant));
  // const showError = (msg) => dispatch(showErrorSnackbar(msg));

  const handlePosSettingsChange = (setting) => (event) => {
    setPosSettings(prev => ({
      ...prev,
      [setting]: event.target.checked
    }));
  };

  // Numeric posSettings keys. An empty field removes the key so the POS falls
  // back to its default rather than reading 0.
  const handlePosSettingsNumberChange = (setting) => (event) => {
    const raw = event.target.value;
    setPosSettings(prev => {
      const next = { ...prev };
      if (raw === '') {
        delete next[setting];
      } else {
        next[setting] = Number(raw);
      }
      return next;
    });
  };

  useEffect(() => {
    if (selectedRestaurant) {
      saveMyRestaurant(selectedRestaurant);
    }
  }, [selectedRestaurant]);

  useEffect(() => {
    if (selectedRestaurant) {
      setName(selectedRestaurant.name);
      setAltName(selectedRestaurant.altName);
      setAddress(selectedRestaurant.address);
      setRestrauntDescription(selectedRestaurant.restrauntDescription);
      setAbn(selectedRestaurant.abn);
      setUrlIdentifier(selectedRestaurant.urlIdentifier);
      setRestaurantAdmin(selectedRestaurant.restaurantAdmin);
      setPaymentPartnerCode(selectedRestaurant.paymentPartnerCode);
      setPaymentPartnerCredential(selectedRestaurant.paymentPartnerCredential);

      setOnline(selectedRestaurant.isOnline);
      if (selectedRestaurant.takeawayPayment === undefined) {
        setTakeawayPayment(true);
      } else {
        setTakeawayPayment(selectedRestaurant.takeawayPayment);
      }
      if (selectedRestaurant.phone) {
        setPhone(selectedRestaurant.phone);
      }

      if (selectedRestaurant.stripeFeeOnUs !== undefined) {
        setStripeFeeOnUs(selectedRestaurant.stripeFeeOnUs);
      }

      if (selectedRestaurant.latitude !== undefined) {
        setLatitude(selectedRestaurant.latitude);
      }

      if (selectedRestaurant.smsVerify !== undefined) {
        setSmsVerify(selectedRestaurant.smsVerify);
      }

      if (selectedRestaurant.isSMSLoyaltyEnabled !== undefined) {
        setIsSMSLoyaltyEnabled(selectedRestaurant.isSMSLoyaltyEnabled);
      }

      if (selectedRestaurant.isFranchise !== undefined) {
        setIsFranchise(selectedRestaurant.isFranchise);
      }

      if (selectedRestaurant.longitude !== undefined) {
        setLongitude(selectedRestaurant.longitude);
      }
      if (
        selectedRestaurant.serviceMonthlyPrice !== undefined &&
        selectedRestaurant.serviceMonthlyPrice !== null
      ) {
        setServiceMonthlyPrice(selectedRestaurant.serviceMonthlyPrice);
      }

      if (
        selectedRestaurant.isApplicationFeeEnabled !== undefined &&
        selectedRestaurant.isApplicationFeeEnabled !== null
      ) {
        setIsApplicationFeeEnabled(selectedRestaurant.isApplicationFeeEnabled);
      }

      if (
        selectedRestaurant.applicationFee !== undefined &&
        selectedRestaurant.applicationFee !== null &&
        !isNaN(selectedRestaurant.applicationFee)
      ) {
        setApplicationFee(Number(selectedRestaurant.applicationFee));
      }

      if (
        selectedRestaurant.restaurantCategory !== undefined &&
        selectedRestaurant.restaurantCategory !== null
      ) {
        setSelectedCategory({
          value: selectedRestaurant.restaurantCategory,
          label: selectedRestaurant.restaurantCategory,
        });
      }

      if (
        selectedRestaurant.restaurantType !== undefined &&
        selectedRestaurant.restaurantType !== null
      ) {
        setSelectedType({
          value: selectedRestaurant.restaurantType,
          label: splitCamelCase(selectedRestaurant.restaurantType),
        });
      }

      if (
        selectedRestaurant.merchantType !== undefined &&
        selectedRestaurant.merchantType !== null
      ) {
        setSelectedMerchantType({
          value: selectedRestaurant.merchantType,
          label: selectedRestaurant.merchantType,
        });
      }

      if (
        selectedRestaurant.terminalProvider !== undefined &&
        selectedRestaurant.terminalProvider !== null
      ) {
        setSelectedTerminalProvider({
          value: selectedRestaurant.terminalProvider,
          label: selectedRestaurant.terminalProvider,
        });
      }

      if (
        selectedRestaurant.onlinePaymentSurchargeRate !== undefined &&
        selectedRestaurant.onlinePaymentSurchargeRate !== null
      ) {
        setOnlinePaymentSurchargeRate(
          selectedRestaurant.onlinePaymentSurchargeRate
        );
      }

      if (
        selectedRestaurant.inPersonPaymentSurchargeRate !== undefined &&
        selectedRestaurant.inPersonPaymentSurchargeRate !== null
      ) {
        setInPersonPaymentSurchargeRate(
          selectedRestaurant.inPersonPaymentSurchargeRate
        );
      }

      if (
        selectedRestaurant.addressObject !== undefined &&
        selectedRestaurant.addressObject !== null
      ) {
        setAddressObject(selectedRestaurant.addressObject);
      }

      if (
        selectedRestaurant.disableAdyenMinimumSurcharge !== undefined &&
        selectedRestaurant.disableAdyenMinimumSurcharge !== null
      ) {
        setDisableAdyenMinimumSurcharge(
          selectedRestaurant.disableAdyenMinimumSurcharge
        );
      }

      if (
        selectedRestaurant.disableOnlineSurcharge !== undefined &&
        selectedRestaurant.disableOnlineSurcharge !== null
      ) {
        setDisableOnlineSurcharge(selectedRestaurant.disableOnlineSurcharge);
      }

      if (
        selectedRestaurant.taxName !== undefined &&
        selectedRestaurant.taxName !== null
      ) {
        setTaxName(selectedRestaurant.taxName);
      }

      if (
        selectedRestaurant.taxPercentage !== undefined &&
        selectedRestaurant.taxPercentage !== null
      ) {
        setTaxPercentage(selectedRestaurant.taxPercentage);
      }

      if (selectedRestaurant.isClosed !== undefined && selectedRestaurant.isClosed !== null) {
        setIsClosed(selectedRestaurant.isClosed);
      }

      if (selectedRestaurant.isKDSDisabled !== undefined && selectedRestaurant.isKDSDisabled !== null) {
        setIsKDSDisabled(selectedRestaurant.isKDSDisabled);
      }

      if (selectedRestaurant.fantuanStoreId !== undefined && selectedRestaurant.fantuanStoreId !== null) {
        setFantuanStoreId(selectedRestaurant.fantuanStoreId);
      }

      if (selectedRestaurant.chinaPaymentsMerchantCode !== undefined && selectedRestaurant.chinaPaymentsMerchantCode !== null) {
        setChinaPaymentsMerchantCode(selectedRestaurant.chinaPaymentsMerchantCode);
      }

      if (selectedRestaurant.merchantId !== undefined && selectedRestaurant.merchantId !== null) {
        setMerchantId(selectedRestaurant.merchantId);
      }

      if (selectedRestaurant.uberStoreName !== undefined && selectedRestaurant.uberStoreName !== null) {
        setUberStoreName(selectedRestaurant.uberStoreName);
      }

      if (selectedRestaurant.hungryPandaStoreId !== undefined && selectedRestaurant.hungryPandaStoreId !== null) {
        setHungryPandaStoreId(selectedRestaurant.hungryPandaStoreId);
      }

      if (selectedRestaurant.huePayMerchantNumber !== undefined && selectedRestaurant.huePayMerchantNumber !== null) {
        setHuePayMerchantNumber(selectedRestaurant.huePayMerchantNumber);
      }

      if (selectedRestaurant.posSettings !== undefined && selectedRestaurant.posSettings !== null) {
        setPosSettings(selectedRestaurant.posSettings);
      }

      if (selectedRestaurant.isDeliveryServiceEnabled !== undefined && selectedRestaurant.isDeliveryServiceEnabled !== null) {
        setIsDeliveryServiceEnabled(selectedRestaurant.isDeliveryServiceEnabled);
      }

      if (
        selectedRestaurant.deliveryServiceOnlineRate !== undefined &&
        selectedRestaurant.deliveryServiceOnlineRate !== null
      ) {
        setDeliveryServiceOnlineRate(selectedRestaurant.deliveryServiceOnlineRate);
      }

      if (
        selectedRestaurant.deliveryServiceCommissionRate !== undefined &&
        selectedRestaurant.deliveryServiceCommissionRate !== null
      ) {
        setDeliveryServiceCommissionRate(selectedRestaurant.deliveryServiceCommissionRate);
      }

      if (
        selectedRestaurant.deliveryServiceCommissionDiscount !== undefined &&
        selectedRestaurant.deliveryServiceCommissionDiscount !== null
      ) {
        setDeliveryServiceCommissionDiscount(selectedRestaurant.deliveryServiceCommissionDiscount);
      }

      if (
        selectedRestaurant.timezone !== undefined &&
        selectedRestaurant.timezone !== null
      ) {
        setTimezone(selectedRestaurant.timezone);
      }
    }
  }, [selectedRestaurant]);

  const handleImageChange = (event) => {
    setImage(event.target.files[0]);
  };

  const handleNameChange = (e) => {
    const value = e.target.value;
    setName(value);
    if (!value) {
      setNameError("Restaurant name is required");
    } else if (value.length < 3) {
      setNameError("Restaurant name must be at least 3 characters long");
    } else {
      setNameError("");
    }
  };

  function isValidUrlIdentifier(urlIdentifier) {
    const regex = /^[a-zA-Z0-9]+$/;
    const result = regex.test(urlIdentifier);
    if (!result) {
      setIdError("The restaurant Id cannot include a space, %, &, -, _ and ?.");
    }
    return result;
  }

  const handleIdChange = (e) => {
    const value = e.target.value;
    setUrlIdentifier(value);
    if (isValidUrlIdentifier(value)) {
      setIdError("");
    }
  };

  const logoPictureHandler = (event) => {
    event.preventDefault();
    setUiLoading(true);
    let form_data = new FormData();
    form_data.append("image", image);
    form_data.append("content", content);
    API.post("/restaurant/image/" + urlIdentifier, form_data, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then(() => {
        setUiLoading(false);
        setOpenSuccessSnackbar(true);
        // Navigate after showing success message
        setTimeout(() => {
          history.push("/restaurants");
        }, 2000);
      })
      .catch((error) => {
        if (error && error.response && error.response.status === 403) {
          history.push("/login");
        }
        console.log(error);
        setUiLoading(false);
        const errorMessage = error.response?.data?.message || error.message || "Error uploading logo";
        setErrorMsg(errorMessage);
        setOpenErrorSnackbar(true);
        setImageError("Error in posting the data");
      });
  };

  const handleErrorClose = (event, reason) => {
    setOpenErrorSnackbar(false);
  };

  const handleSuccessClose = (event, reason) => {
    setOpenSuccessSnackbar(false);
    setButtonLoading(false);
  };

  const updateFormValues = (event) => {
    event.preventDefault();

    if (!selectedRestaurant && !isValidUrlIdentifier(urlIdentifier)) {
      return;
    }

    const phoneErr = validatePhone(phone);
    setPhoneError(phoneErr);
    if (phoneErr) {
      setErrorMsg(phoneErr);
      setOpenErrorSnackbar(true);
      return;
    }

    if(!Number.isInteger(Number(taxPercentage))) {
      setErrorMsg("Tax percentage must be an integer");
      setOpenErrorSnackbar(true);
      return;
    }

    if (Number(taxPercentage) < 0 || Number(taxPercentage) > 100) {
      setErrorMsg("Tax percentage must be between 0 and 100");
      setOpenErrorSnackbar(true);
      return;
    }

    const deliveryDiscountValidationError = validateDeliveryCommissionDiscount(
      deliveryServiceCommissionDiscount,
      deliveryServiceCommissionRate
    );
    setDeliveryCommissionDiscountError(deliveryDiscountValidationError);
    if (deliveryDiscountValidationError) {
      setErrorMsg(deliveryDiscountValidationError);
      setOpenErrorSnackbar(true);
      return;
    }

    setButtonLoading(true);
    const formRequest = {
      name,
      altName,
      address: address,
      restrauntDescription: restrauntDescription,
      abn: abn,
      taxName,
      taxPercentage: Number(taxPercentage),
      restaurantAdmin: restaurantAdmin,
      urlIdentifier: urlIdentifier,
      paymentPartnerCredential: paymentPartnerCredential,
      paymentPartnerCode: paymentPartnerCode,
      isOnline: online,
      takeawayPayment,
      phone,
      stripeFeeOnUs,
      latitude: Number(latitude),
      longitude: Number(longitude),
      smsVerify,
      isSMSLoyaltyEnabled,
      isFranchise,
      type: "restaurant",
      serviceMonthlyPrice,
      applicationFee: Number(applicationFee),
      restaurantType:
        selectedType && selectedType.value ? selectedType.value : null,
      restaurantCategory:
        selectedCategory && selectedCategory.value
          ? selectedCategory.value
          : null,
      merchantType:
        selectedMerchantType && selectedMerchantType.value
          ? selectedMerchantType.value
          : null,
      terminalProvider:
        selectedTerminalProvider && selectedTerminalProvider.value
          ? selectedTerminalProvider.value
          : null,
      fantuanStoreId,
      onlinePaymentSurchargeRate: Number(onlinePaymentSurchargeRate),
      inPersonPaymentSurchargeRate: Number(inPersonPaymentSurchargeRate),
      addressObject: addressObject,
      disableAdyenMinimumSurcharge,
      disableOnlineSurcharge,
      timezone,
      chinaPaymentsMerchantCode,
      merchantId,
      uberStoreName,
      hungryPandaStoreId,
      huePayMerchantNumber,
      posSettings,
      isDeliveryServiceEnabled,
      deliveryServiceOnlineRate: Number(deliveryServiceOnlineRate),
      deliveryServiceCommissionRate: Number(deliveryServiceCommissionRate),
      deliveryServiceCommissionDiscount: Number(deliveryServiceCommissionDiscount),
      isClosed,
      isKDSDisabled,
    };
    if (selectedRestaurant) {
      // A Menu Admin's save must carry only the fields their role may change; the
      // server strips these too, this just keeps the request honest.
      const updateRequest = isAdmin
        ? formRequest
        : omitAdminOnlyFields(formRequest);
      updateMutation.mutate({ restaurantId: urlIdentifier, data: updateRequest });
    } else {
      createMutation.mutate(formRequest);
    }
  };

  const splitCamelCase = (str) => {
    return str
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/\b([A-Z]+)([A-Z])([a-z])/, "$1 $2$3")
      .replace(/^./, (str) => {
        return str.toUpperCase();
      });
  };

  const restaurantTypes = [
    "Bakery",
    "Beverages",
    "BreakfastAndBrunch",
    "BubbleTea",
    "Buffet",
    "Cafe",
    "CasualDining",
    "Coffee",
    "FamilyStyle",
    "FastFood",
    "FineDining",
    "FishChips",
    "Halal",
    "IceCreamAndFrozenYoghurt",
    "JuiceAndSmoothies",
    "Seafood",
    "Steakhouse",
    "Vegetarian",
  ].map((type) => ({ value: type, label: splitCamelCase(type) }));

  const restaurantCategories = [
    "Arabian",
    "Australian",
    "Chinese",
    "Indian",
    "Italian",
    "Japanese",
    "Korean",
    "Lebanese",
    "Malaysian",
    "Mediterranean",
    "Mexican",
    "Persian",
    "Portuguese",
    "Thai",
    "Turish",
    "Vietnamese",
  ].map((category) => ({ value: category, label: category }));

  // Which EFTPOS terminal sits on the counter. Normally derived automatically:
  // the POS reports an enabled ANZ terminal via obAppSettings.IsANZTerminalEnabled,
  // and Adyen terminals require adyenPaymentSettings. Setting a value here
  // overrides that derivation on the restaurant list (e.g. an unintegrated
  // bank terminal the POS knows nothing about).
  const terminalProviderOptions = ["Adyen", "ANZ", "Other"].map((provider) => ({
    value: provider,
    label: provider,
  }));



  const handlePhoneChange = (fullPhone) => {
    setPhone(fullPhone);
    setPhoneError(validatePhone(fullPhone));
  };

  const handleAddressChange = (newAddress) => {
    const addressString = `${newAddress.line1} ${newAddress.line2} ${newAddress.line3} ${newAddress.city} ${newAddress.stateOrProvince} ${newAddress.country} ${newAddress.postalCode}`;
    setAddress(addressString);
    setAddressObject(newAddress);
    if (newAddress.location) {
      setLatitude(newAddress.location.lat);
      setLongitude(newAddress.location.lng);
    }
  };

  const handleSelectChange = selectedOption => {
    setTimezone(selectedOption.value);
  };

  if (uiLoading || isRestaurantLoading) {
    return (
      <main className={classes.content}>
        <CircularProgress size={150} className={classes.uiProgess} />
      </main>
    );
  } else {
    return (
      <div className={classes.root}>
        {selectedRestaurant ? (
          <RestaurantToolbar restaurant={selectedRestaurant} />
        ) : null}
        <div className={classes.content}>
          <Card className={clsx(classes.root, classes)}>
            <form autoComplete="off" noValidate>
              <Divider />
              <CardContent style={{ padding: 12 }}>
                <Grid container spacing={1}>
                  {selectedRestaurant && selectedRestaurant.logo ? (
                    <img
                      src={selectedRestaurant.logo}
                      alt="logo"
                      height={100}
                      width={200}
                    />
                  ) : null}
                  <Grid item md={6} xs={12}>
                    <div>
                      <Typography gutterBottom variant="h4">
                        Upload Restaurant Logo
                      </Typography>
                      <Button
                        variant="outlined"
                        color="primary"
                        type="submit"
                        size="small"
                        startIcon={<CloudUploadIcon />}
                        className={classes.uploadButton}
                        onClick={logoPictureHandler}
                      >
                        Upload Logo
                      </Button>
                      <input type="file" onChange={handleImageChange} />

                      {imageError ? (
                        <div className={classes.customError}>
                          {" "}
                          Wrong Image Format || Supported Format are PNG and JPG
                        </div>
                      ) : (
                        false
                      )}
                    </div>
                  </Grid>
                  {isAdmin && (
                    <Grid item xs={12}>
                      <FormControlLabel
                        control={
                          <IOSSwitch
                            checked={isClosed}
                            onChange={(e) => setIsClosed(e.target.checked)}
                            name="isClosed"
                          />
                        }
                        label="Close Restaurant"
                      />
                      <Typography variant="caption" color="textSecondary" display="block">
                        Disables POS and online ordering for this restaurant.
                      </Typography>
                    </Grid>
                  )}

                  <Grid item md={6} xs={12}>
                    <TextField
                      fullWidth
                      label="Restaurant Name *"
                      margin="dense"
                      name="name"
                      variant="outlined"
                      value={name}
                      error={!!nameError}
                      helperText={nameError}
                      onChange={handleNameChange}
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <TextField
                      fullWidth
                      label="Restaurant Alt Name"
                      margin="dense"
                      name="altName"
                      variant="outlined"
                      value={altName}
                      onChange={(e) => setAltName(e.target.value)}
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <FormControlLabel
                      control={
                        <IOSSwitch
                          checked={online}
                          onChange={(e) => setOnline(e.target.checked)}
                          name="online"
                        />
                      }
                      label="Online"
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <TextField
                      fullWidth
                      label="Restaurant description"
                      margin="dense"
                      name="restrauntDescription"
                      variant="outlined"
                      value={restrauntDescription}
                      onChange={(e) => setRestrauntDescription(e.target.value)}
                    />
                  </Grid>

                  <Grid item md={12} xs={12}>
                    <TextField
                      fullWidth
                      label="Address"
                      margin="dense"
                      name="address"
                      variant="outlined"
                      disabled
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                    />
                    <AddressField
                      onAddressChange={handleAddressChange}
                      addressObject={addressObject}
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <PhoneField
                      value={phone}
                      onChange={handlePhoneChange}
                      addressCountryCode={addressObject?.countryCode}
                      error={!!phoneError}
                      helperText={phoneError}
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <TextField
                      fullWidth
                      label="Tax Number"
                      margin="dense"
                      name="abn"
                      variant="outlined"
                      value={abn}
                      onChange={(e) => setAbn(e.target.value)}
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <TextField
                      fullWidth
                      label="Tax Name"
                      margin="dense"
                      name="taxName"
                      
                      variant="outlined"
                      value={taxName}
                      onChange={(e) => setTaxName(e.target.value)}
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <TextField
                      fullWidth
                      label="Tax Percentage %"
                      margin="dense"
                      name="taxPercentage"
                      type="number"
                      inputProps={noWheelInputProps}
                      variant="outlined"
                      value={taxPercentage}
                      onChange={(e) => setTaxPercentage(e.target.value)}
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <TextField
                      fullWidth
                      label="Restaurant identifier (used for order website) *"
                      margin="dense"
                      name="urlIdentifier"
                      variant="outlined"
                      disabled={selectedRestaurant}
                      value={urlIdentifier}
                      onChange={handleIdChange}
                      error={!!idError}
                      helperText={idError}
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>


                    <Select
                      className={classes.select}
                      value={{ label: timezone, value: timezone }}
                      onChange={handleSelectChange}
                      options={timezoneOptions}
                      placeholder="Select a timezone"
                      styles={{
                        menu: (provided) => ({
                          ...provided,
                          zIndex: 9999,
                        }),
                      }}
                    />


                  </Grid>

                  {isAdmin && (
                    <Grid item md={6} xs={12}>
                      <Autocomplete
                        id="username-autocomplete"
                        options={usernameOptions || []}
                        getOptionLabel={(option) => option.username}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label=" Merchant Admin"
                            variant="outlined"
                            value={restaurantAdmin}
                            fullWidth
                          />
                        )}
                        onInputChange={(event, value) => {
                          setRestaurantAdmin(value);
                        }}
                      />
                    </Grid>
                  )}

                  <Grid item md={6} xs={12}>
                    <TextField
                      fullWidth
                      label="Retaurant latitude"
                      margin="dense"
                      name="latitude"
                      variant="outlined"
                      value={latitude}
                      onChange={(e) => setLatitude(e.target.value)}
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <TextField
                      fullWidth
                      label="Retaurant longitude"
                      margin="dense"
                      name="longitude"
                      variant="outlined"
                      value={longitude}
                      onChange={(e) => setLongitude(e.target.value)}
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <Select
                      value={selectedType}
                      onChange={setSelectedType}
                      options={restaurantTypes}
                      placeholder="Select Restaurant Type"
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <Select
                      value={selectedCategory}
                      onChange={setSelectedCategory}
                      options={restaurantCategories}
                      placeholder="Select Category"
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <Select
                      value={selectedMerchantType}
                      onChange={setSelectedMerchantType}
                      options={merchantTypes}
                      placeholder="Select Merchant Type"
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <FormControlLabel
                      control={
                        <IOSSwitch
                          checked={takeawayPayment}
                          onChange={(e) => setTakeawayPayment(e.target.checked)}
                          name="takeawayPayment"
                        />
                      }
                      label="Takeaway Online Payment"
                    />
                  </Grid>

                  {isAdmin && (
                    <Grid item md={6} xs={12}>
                      <FormControlLabel
                        control={
                          <IOSSwitch
                            checked={stripeFeeOnUs}
                            onChange={(e) => setStripeFeeOnUs(e.target.checked)}
                            name="stripeFeeOnUs"
                          />
                        }
                        label="Stripe fee on us"
                      />
                    </Grid>
                  )}

                  <Grid item md={6} xs={12}>
                    <FormControlLabel
                      control={
                        <IOSSwitch
                          checked={smsVerify}
                          onChange={(e) => setSmsVerify(e.target.checked)}
                          name="smsVerify"
                        />
                      }
                      label="SMS Verification"
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <FormControlLabel
                      control={
                        <IOSSwitch
                          checked={isSMSLoyaltyEnabled}
                          onChange={(e) => setIsSMSLoyaltyEnabled(e.target.checked)}
                          name="isSMSLoyaltyEnabled"
                        />
                      }
                      label="SMS Loyalty Enabled"
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <FormControlLabel
                      control={
                        <IOSSwitch
                          checked={isFranchise}
                          onChange={(e) => setIsFranchise(e.target.checked)}
                          name="isFranchise"
                        />
                      }
                      label="Is Franchise"
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <FormControlLabel
                      control={
                        <IOSSwitch
                          checked={disableAdyenMinimumSurcharge}
                          onChange={(e) =>
                            setDisableAdyenMinimumSurcharge(e.target.checked)
                          }
                          name="disableAdyenMinimumSurcharge"
                        />
                      }
                      label="Disable Adyen minimum surcharge"
                    />
                  </Grid>

                  {isAdmin && (
                    <>
                      <Grid item md={6} xs={12}>
                        <TextField
                          fullWidth
                          label="Service monthly price"
                          margin="dense"
                          type="number"
                          inputProps={noWheelInputProps}
                          name="serviceMonthlyPrice"
                          variant="standard"
                          value={serviceMonthlyPrice}
                          onChange={(e) =>
                            setServiceMonthlyPrice(Number(e.target.value))
                          }
                        />
                      </Grid>

                      <Grid item md={6} xs={12}>
                        <TextField
                          fullWidth
                          label="Online Payment surcharge rate (%)"
                          margin="dense"
                          type="text"
                          name="onlinePaymentSurchargeRate"
                          variant="standard"
                          value={onlinePaymentSurchargeRate}
                          onChange={handleRateChange(setOnlinePaymentSurchargeRate)}
                          inputProps={{ inputMode: "decimal" }}
                        />
                      </Grid>
                      <Grid item md={6} xs={12}>
                        <FormControlLabel
                          control={
                            <IOSSwitch
                              checked={disableOnlineSurcharge}
                              onChange={(e) =>
                                setDisableOnlineSurcharge(e.target.checked)
                              }
                              name="disableOnlineSurcharge"
                            />
                          }
                          label="Disable online card surcharge (commission taken from merchant) — automatic for all stores from 1 Oct 2026"
                        />
                      </Grid>
                      <Grid item md={6} xs={12}>
                        <TextField
                          fullWidth
                          label="In person payment surcharge rate (%)"
                          margin="dense"
                          type="text"
                          name="inPersonPaymentSurchargeRate"
                          variant="standard"
                          value={inPersonPaymentSurchargeRate}
                          onChange={handleRateChange(
                            setInPersonPaymentSurchargeRate
                          )}
                          inputProps={{ inputMode: "decimal" }}
                        />
                      </Grid>
                      <Grid item md={6} xs={12}>
                        <Select
                          value={selectedTerminalProvider}
                          onChange={setSelectedTerminalProvider}
                          options={terminalProviderOptions}
                          placeholder="Select POS Terminal (Adyen / ANZ / Other)"
                          isClearable
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                        />
                      </Grid>
                    </>
                  )}

                  <Grid item xs={12}>
                    <Box
                      sx={{
                        mt: 2,
                        p: 2,
                        borderRadius: 2,
                        backgroundColor: '#f0f7ff',
                        border: '1px solid #c2dff7',
                      }}
                    >
                      <Typography variant="h6" gutterBottom>
                        Delivery
                      </Typography>
                      <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                        Configure delivery service and commission settings
                      </Typography>

                      <Grid container spacing={2}>
                        <Grid item md={6} xs={12}>
                          <FormControlLabel
                            control={
                              <IOSSwitch
                                checked={isDeliveryServiceEnabled}
                                onChange={(e) => setIsDeliveryServiceEnabled(e.target.checked)}
                                name="isDeliveryServiceEnabled"
                              />
                            }
                            label="Delivery Service Enabled"
                          />
                        </Grid>

                        {isAdmin && isDeliveryServiceEnabled && (
                          <>
                            <Grid item md={6} xs={12}>
                              <TextField
                                fullWidth
                                label="Online rate (%)"
                                margin="dense"
                                type="text"
                                name="deliveryServiceOnlineRate"
                                variant="outlined"
                                value={deliveryServiceOnlineRate}
                                onChange={handleRateChange(setDeliveryServiceOnlineRate)}
                                inputProps={{ inputMode: "decimal" }}
                              />
                            </Grid>

                            <Grid item md={6} xs={12}>
                              <TextField
                                fullWidth
                                label="Commission rate (%)"
                                margin="dense"
                                type="text"
                                name="deliveryServiceCommissionRate"
                                variant="outlined"
                                value={deliveryServiceCommissionRate}
                                onChange={handleDeliveryCommissionRateChange}
                                inputProps={{ inputMode: "decimal" }}
                              />
                            </Grid>

                            <Grid item md={6} xs={12}>
                              <TextField
                                fullWidth
                                label="Commission discount to customer (%)"
                                margin="dense"
                                type="text"
                                name="deliveryServiceCommissionDiscount"
                                variant="outlined"
                                value={deliveryServiceCommissionDiscount}
                                onChange={handleDeliveryCommissionDiscountChange}
                                error={!!deliveryCommissionDiscountError}
                                helperText={
                                  deliveryCommissionDiscountError ||
                                  "Cannot exceed commission rate"
                                }
                                inputProps={{ inputMode: "decimal" }}
                              />
                            </Grid>
                          </>
                        )}
                      </Grid>
                    </Box>
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <TextField
                      fullWidth
                      label="Fantuan Shop ID"
                      margin="dense"
                      name="fantuanStoreId"
                      variant="outlined"
                      value={fantuanStoreId}
                      onChange={(e) => setFantuanStoreId(e.target.value)}
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <TextField
                      fullWidth
                      label="China Payments Merchant Code"
                      margin="dense"
                      name="chinaPaymentsMerchantCode"
                      variant="outlined"
                      value={chinaPaymentsMerchantCode}
                      onChange={(e) => setChinaPaymentsMerchantCode(e.target.value)}
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <TextField
                      fullWidth
                      label="Orderbuddy App Merchant Id"
                      margin="dense"
                      name="merchantId"
                      variant="outlined"
                      value={merchantId}
                      onChange={(e) => setMerchantId(e.target.value)}
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <TextField
                      fullWidth
                      label="Uber Store Name"
                      margin="dense"
                      name="uberStoreName"
                      variant="outlined"
                      value={uberStoreName}
                      onChange={(e) => setUberStoreName(e.target.value)}
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <TextField
                      fullWidth
                      label="Hungry Panda Store ID"
                      margin="dense"
                      name="hungryPandaStoreId"
                      variant="outlined"
                      value={hungryPandaStoreId}
                      onChange={(e) => setHungryPandaStoreId(e.target.value)}
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <TextField
                      fullWidth
                      label="HuePay Merchant Number"
                      margin="dense"
                      name="huePayMerchantNumber"
                      variant="outlined"
                      value={huePayMerchantNumber}
                      onChange={(e) => setHuePayMerchantNumber(e.target.value)}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Divider style={{ marginTop: 16, marginBottom: 8 }} />
                    <Typography variant="h6" gutterBottom>
                      POS Settings
                    </Typography>
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <FormControlLabel
                      control={
                        <IOSSwitch
                          checked={posSettings.showRemoveTakeawayOrders}
                          onChange={handlePosSettingsChange('showRemoveTakeawayOrders')}
                          name="showRemoveTakeawayOrders"
                        />
                      }
                      label="Show Remove All Takeaway Orders Button"
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <FormControlLabel
                      control={
                        <IOSSwitch
                          checked={!!posSettings.showClearAllPickupOrders}
                          onChange={handlePosSettingsChange('showClearAllPickupOrders')}
                          name="showClearAllPickupOrders"
                        />
                      }
                      label="Show Clear All Pickup Orders Button"
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <FormControlLabel
                      control={
                        <IOSSwitch
                          checked={!!posSettings.singleDiscountPerTable}
                          onChange={handlePosSettingsChange('singleDiscountPerTable')}
                          name="singleDiscountPerTable"
                        />
                      }
                      label="Only allow a single discount per table"
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <FormControlLabel
                      control={
                        <IOSSwitch
                          checked={!!posSettings.requireMembershipOtp}
                          onChange={handlePosSettingsChange('requireMembershipOtp')}
                          name="requireMembershipOtp"
                        />
                      }
                      label="Verify loyalty members with a one-time code"
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <FormControlLabel
                      control={
                        <IOSSwitch
                          checked={isKDSDisabled}
                          onChange={(e) => setIsKDSDisabled(e.target.checked)}
                          name="isKDSDisabled"
                        />
                      }
                      label="Disable KDS (Kitchen Display System)"
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <TextField
                      type="number"
                      label="Kitchen alert minutes"
                      helperText="Minutes a dish may go unprinted or unsent to the kitchen display before the POS sounds an alert. Blank = 5."
                      name="kitchenAlertMinutes"
                      value={posSettings.kitchenAlertMinutes ?? ''}
                      onChange={handlePosSettingsNumberChange('kitchenAlertMinutes')}
                      inputProps={{ min: 1, max: 60, step: 1, 'aria-label': 'Kitchen alert minutes' }}
                      variant="outlined"
                      size="small"
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </CardContent>

              { canSave ? (
                <CardActions className={classes.cardActions}>
                  <Button
                    color="primary"
                    variant="contained"
                    type="submit"
                    size="large"
                    className={classes.submitButton}
                    onClick={updateFormValues}
                    disabled={buttonLoading || !name || !urlIdentifier || !timezone || !!phoneError}
                  >
                    Save Restaurant
                    {buttonLoading && (
                      <CircularProgress size={24} className={classes.progess} style={{ marginLeft: 8 }} />
                    )}
                  </Button>
                </CardActions>
              ) : null }
            </form>
          </Card>
          <Snackbar
            open={openSuccessSnackbar}
            autoHideDuration={2000}
            onClose={handleSuccessClose}
          >
            <Alert onClose={handleSuccessClose} severity="success">
              Restaurant saved successfully!
            </Alert>
          </Snackbar>
          <Snackbar
            open={openErrorSnackbar}
            autoHideDuration={2000}
            onClose={handleErrorClose}
          >
            <Alert onClose={handleErrorClose} severity="error">
              {errorMsg ? errorMsg : "Something went wrong! Please try again."}
            </Alert>
          </Snackbar>
        </div>
      </div>
    );
  }
};

export default Restaurant;
